<template>
  <f7-page>
    <div>
      <div class="cardRegister card">
        <div class="summary-header">
          <div class="summary-title">
            <div class="summary-icon"></div>
            <div class="summary-text">
              {{ $t('InvoiceDeliveryHeaderEdit') }} {{ invoiceCode }}
            </div>
          </div>
        </div>

        <div class="card-content padding">
          <div class="input-full">
            <DxForm
              :form-data="formDataCheck"
              label-location="top"
              :show-colon-after-label="false"
              :col-count="10"
              class="checkbox-independent-shipping"
            >
              <DxGroupItem :col-count="10" :col-span="10">
                <DxItem
                  editor-type="dxCheckBox"
                  data-field="AgenciaAjena"
                  :col-span="10"
                  :editor-options="{
                    text: $t('independentShippingMessage'),
                    disabled: isShippingDateLocked,
                  }"
                />
              </DxGroupItem>
            </DxForm>

            <DxForm
              label-location="top"
              :show-colon-after-label="false"
              :col-count="10"
              :form-data="formData"
            >
              <DxGroupItem
                v-if="!formDataCheck.AgenciaAjena"
                :col-count="10"
                :col-span="10"
              >
                <DxItem
                  data-field="Agencia"
                  editor-type="dxSelectBox"
                  :col-span="5"
                  :editor-options="{
                    dataSource: agencies,
                    displayExpr: 'AgenciaPais',
                    valueExpr: 'idAgencia',
                    searchEnabled: true,
                    disabled: isShippingDateLocked,
                  }"
                >
                  <DxLabel :text="$t('courier_agency')" />
                </DxItem>

                <DxItem
                  data-field="shippingDate"
                  editor-type="dxDateBox"
                  :col-span="5"
                  :editor-options="{
                    type: 'date',
                    displayFormat: $helpers.getDateFormat(company),
                    width: '100%',
                    disabled: isShippingDateLocked,
                  }"
                >
                  <DxLabel :text="$t('shipping_date')" />
                </DxItem>
              </DxGroupItem>

              <DxGroupItem v-else :col-count="10" :col-span="10">
                <DxItem
                  data-field="AgenciaLiteral"
                  editor-type="dxTextBox"
                  :col-span="5"
                  :editor-options="{
                    disabled: isShippingDateLocked,
                    maxLength: 50,
                  }"
                >
                  <DxLabel :text="$t('courier_agency')" />
                </DxItem>

                <DxItem
                  data-field="shippingDate"
                  editor-type="dxDateBox"
                  :col-span="5"
                  :editor-options="{
                    type: 'date',
                    displayFormat: $helpers.getDateFormat(company),
                    width: '100%',
                    disabled: isShippingDateLocked,
                  }"
                >
                  <DxLabel :text="$t('shipping_date')" />
                </DxItem>
              </DxGroupItem>

              <DxItem
                data-field="observations"
                editor-type="dxTextArea"
                :col-span="10"
                :editor-options="{ height: 90, maxLength: 250 }"
              >
                <DxLabel :text="$t('observations')" />
              </DxItem>

              <DxItem
                data-field="orderNumber"
                editor-type="dxTextBox"
                :col-span="10"
                :editor-options="{
                  maxLength: isTempSampleEditLocked ? 50 : undefined,
                }"
              >
                <DxLabel :text="$t('purchase_order')" />
              </DxItem>
            </DxForm>

            <div
              v-if="showColombiaResponsibility"
              class="colombia-responsibility-row"
            >
              <DxCheckBox
                :value="colombiaResponsibilityAccepted"
                :read-only="true"
                :focus-state-enabled="false"
                :hover-state-enabled="false"
                :active-state-enabled="false"
                :text="
                  $t(
                    'samplesRegister.colombiaResponsibilityMessage'
                  )
                "
              />
            </div>
          </div>
          <div
            class="content-setting display-flex justify-content-flex-start margin-top"
          >
            <f7-button
              class="cancelButton"
              fill
              outline
              type="default"
              styling-mode="contained"
              @click="goBack"
            >
              {{ $t('cancel') }}
            </f7-button>

            <f7-button
              class="botones-registrar whiteFontColor margin-left saveButton"
              fill
              outline
              type="default"
              styling-mode="contained"
              @click="saveDeliveryHeader"
            >
              {{ $t('save') }}
            </f7-button>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import {
  DxForm,
  DxItem,
  DxLabel,
  DxGroupItem,
} from 'devextreme-vue/form';
import DxCheckBox from 'devextreme-vue/check-box';
import { mapActions, mapState } from 'vuex';
import {
  NOTIFY_TIME_LONG,
  ENABLE_TEMP_SAMPLE_EDIT_LOCK,
} from '@/js/constants';

export default {
  components: {
    DxForm,
    DxItem,
    DxLabel,
    DxGroupItem,
    DxCheckBox,
  },
  data() {
    return {
      formDataCheck: {
        AgenciaAjena: false,
      },
      formData: {
        Agencia: null,
        AgenciaLiteral: '',
        shippingDate: null,
        observations: '',
        orderNumber: '',
      },
    };
  },
  computed: {
    // TEMP_BLOQUEO_EDITAR_MUESTRA
    isTempSampleEditLocked() {
      return ENABLE_TEMP_SAMPLE_EDIT_LOCK;
    },
    shippingDateReference() {
      return (
        this.invoiceDetails?.FechaRecogidaDate ||
        this.invoiceDetails?.FechaRecogida ||
        this.formData.shippingDate
      );
    },
    isShippingDateLocked() {
      const shippingDate = this.normalizeDateOnly(
        this.shippingDateReference
      );
      const today = this.normalizeDateOnly(new Date());

      if (!shippingDate || !today) {
        return false;
      }

      return shippingDate.getTime() <= today.getTime();
    },
    isColombiaClient() {
      return String(
        this.invoiceDetails?.CodCliente || this.company || ''
      )
        .trim()
        .toUpperCase()
        .startsWith('CO');
    },
    showColombiaResponsibility() {
      return this.isColombiaClient;
    },
    colombiaResponsibilityAccepted() {
      return this.showColombiaResponsibility;
    },
    ...mapState('contact', ['company']),
    ...mapState('samplesRegisterModule', [
      'invoice',
      'invoiceSamples',
      'invoiceCode',
      'invoiceDetails',
      'agencies',
    ]),
  },
  watch: {
    'formDataCheck.AgenciaAjena'(isIndependentShipping) {
      if (isIndependentShipping) {
        this.formData.Agencia = null;
      } else {
        this.formData.AgenciaLiteral = '';
      }
    },
  },
  async mounted() {
    try {
      if (!Array.isArray(this.agencies) || !this.agencies.length) {
        await this.fetchAgencies();
      }

      if (!this.invoiceDetails && this.invoiceCode) {
        await this.fetchAlbaranes();
        const currentInvoice = (this.invoice || []).find(
          (item) => item.CodAlbaran === this.invoiceCode
        );
        if (currentInvoice) {
          this.setInvoiceDetails(currentInvoice);
        }
      }

      this.hydrateForm();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(error.message)
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    }
  },
  methods: {
    isIndependentShippingInvoice() {
      return Boolean(this.invoiceDetails?.AgenciaLiteral?.trim());
    },
    hydrateForm() {
      const uniqueOrders = [
        ...new Set(
          (this.invoiceSamples || [])
            .map((sample) => sample?.Pedido)
            .filter(
              (value) =>
                typeof value === 'string' && value.trim() !== ''
            )
        ),
      ];

      const isIndependentShipping =
        this.isIndependentShippingInvoice();

      this.formDataCheck.AgenciaAjena = isIndependentShipping;

      this.formData = {
        Agencia: isIndependentShipping
          ? null
          : this.invoiceDetails?.idAgenciaMensajeria ??
            this.invoiceDetails?.idAgencia ??
            null,
        AgenciaLiteral: isIndependentShipping
          ? this.invoiceDetails?.AgenciaLiteral || ''
          : '',
        shippingDate: this.normalizeDate(
          this.invoiceDetails?.FechaRecogidaDate ||
            this.invoiceDetails?.FechaRecogida
        ),
        observations: this.invoiceDetails?.Observaciones || '',
        orderNumber: uniqueOrders.join('; '),
      };
    },
    normalizeDate(value) {
      if (!value) return null;
      const parsedDate = new Date(value);
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    },
    normalizeDateOnly(value) {
      if (!value) return null;

      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) {
        return null;
      }

      return new Date(
        parsedDate.getFullYear(),
        parsedDate.getMonth(),
        parsedDate.getDate()
      );
    },
    async saveDeliveryHeader() {
      const normalizedOrderNumber =
        this.formData.orderNumber?.toString().trim() || '';
      const normalizedAgencyLiteral =
        this.formData.AgenciaLiteral?.toString().trim() || '';
      const isIndependentShipping =
        this.formDataCheck.AgenciaAjena === true;

      if (
        !this.formData.shippingDate ||
        (!isIndependentShipping && !this.formData.Agencia) ||
        (isIndependentShipping && !normalizedAgencyLiteral)
      ) {
        this.$notifyDX(
          {
            message: this.$t('samplesRegister.missingFieldsError'),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return;
      }

      try {
        this.$f7.preloader.show();

        if (normalizedOrderNumber) {
          await Promise.all(
            (this.invoiceSamples || []).map((sample) =>
              this.updateSample({
                ...sample,
                checkNumPedido: true,
                orderNumber: normalizedOrderNumber,
              })
            )
          );
        }

        await this.updateInvoice({
          idAlbaran: this.invoiceDetails?.idAlbaran,
          CodAlbaran: this.invoiceDetails?.CodAlbaran,
          CodCliente: this.invoiceDetails?.CodCliente,
          FechaAlta:
            this.invoiceDetails?.FechaAltaDate ||
            this.invoiceDetails?.FechaAlta ||
            null,
          updateSource: 'albaran_detail',
          Agencia: isIndependentShipping ? 8 : this.formData.Agencia,
          AgenciaLiteral: isIndependentShipping
            ? normalizedAgencyLiteral
            : '',
          shippingDate: this.formData.shippingDate,
          observations: this.formData.observations || '',
        });

        await this.fetchAlbaranes();
        const refreshedInvoice = (this.invoice || []).find(
          (item) => item.CodAlbaran === this.invoiceCode
        );
        if (refreshedInvoice) {
          this.setInvoiceDetails(refreshedInvoice);
        }

        if (this.invoiceDetails?.idAlbaran) {
          await this.fetchInvoiceSamples(
            this.invoiceDetails.idAlbaran
          );
        }

        this.$notifyDX(
          {
            message: this.$t('editSuccess'),
            width: 550,
          },
          'success',
          NOTIFY_TIME_LONG
        );

        this.goBack();
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    goBack() {
      this.$f7router.navigate(
        { name: 'InvoiceSamplesListDetails' },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    ...mapActions('samplesRegisterModule', [
      'fetchAgencies',
      'fetchAlbaranes',
      'fetchInvoiceSamples',
      'setInvoiceDetails',
      'updateInvoice',
      'updateSample',
    ]),
  },
};
</script>

<style scoped>
.cardRegister {
  max-width: 100%;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(87, 84, 95, 0.3);
  padding: 20px;
}

.saveButton {
  margin: 0 5px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
}

.cancelButton {
  margin: 0 5px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 12px;
  color: #00346a !important;
  background: #fff !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid #00346a !important;
  box-shadow: none;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.2s ease;
}

.cancelButton:hover {
  background: #ebf2fa !important;
}

.shippingDateFull :deep(.dx-datebox),
.shippingDateFull :deep(.dx-texteditor),
.shippingDateFull :deep(.dx-texteditor-container) {
  width: 100% !important;
}
.checkbox-independent-shipping {
  margin: 0px 0px 20px;
}

.colombia-responsibility-row {
  margin-top: 16px;
  margin-bottom: 30px;
  margin-left: 5px;
}

.colombia-responsibility-row :deep(.dx-checkbox) {
  display: flex;
  align-items: flex-start;
  width: 100%;
  color: #6f7780;
  cursor: default;
}

.colombia-responsibility-row :deep(.dx-checkbox-container) {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.colombia-responsibility-row :deep(.dx-checkbox-icon) {
  flex: 0 0 auto;
  margin-top: 2px;
  border: 2px solid #838e99;
  border-radius: 4px;
  background: #f3f5f7;
}

.colombia-responsibility-row
  :deep(.dx-checkbox-checked .dx-checkbox-icon) {
  color: #6f7780;
}

.colombia-responsibility-row
  :deep(.dx-checkbox-checked .dx-checkbox-icon::before) {
  color: #6f7780;
}

.colombia-responsibility-row :deep(.dx-checkbox-text) {
  color: #3d3537;
  flex: 1 1 auto;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 1.45;
}
</style>
